import { createFileRoute } from "@tanstack/react-router";
import { AdminShell } from "@/components/admin/AdminShell";
import { ApprovalsPage } from "@/components/admin/ApprovalsPage";
import { requireAdmin } from "@/lib/require-admin";

export const Route = createFileRoute("/admin_/approvals")({
  beforeLoad: () => {
    requireAdmin();
  },
  component: () => (
    <AdminShell page="approvals">
      <ApprovalsPage />
    </AdminShell>
  ),
});
